"use client"

import * as React from "react"
import Link from "next/link"
import {usePathname} from "next/navigation"

import {cn} from "@/lib/utils"
import {Icons} from "@/components/icons"
import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem, NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger
} from "@/registry/default/ui/navigation-menu";
import {useTranslations} from "next-intl";
import {buttonVariants} from "@/registry/new-york/ui/button";
import { useEditorConfig } from '@/hooks/use-editor'
import { MonitorSmartphone } from 'lucide-react'
import Image from 'next/image'

interface RootNavProps {
    bg?: string
}

export function RootNav({bg}: RootNavProps) {
    return (
        <div className={cn("mr-4 hidden md:flex",bg?" text-foreground dark:text-secondary":" text-secondary dark:text-foreground")}>
            <Link href={"/"} className="mr-10 flex items-center space-x-4">
                <Image alt={'logo'} width={14} height={14} src={'/logo.svg'} className="h-14 w-14"/>
            </Link>
        </div>
    )
}

const ListItem = React.forwardRef<
    React.ElementRef<"a">,
    React.ComponentPropsWithoutRef<"a">
>(({className, title, children, ...props}, ref) => {
    return (
        <li>
            <NavigationMenuLink asChild>
                <a
                    ref={ref}
                    className={cn(
                        "block select-none space-y-0 rounded-md p-2 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
                        className
                    )}
                    {...props}
                >
                    <div className="text-md font-medium leading-none">{title}</div>
                    {children}
                </a>
            </NavigationMenuLink>
        </li>
    )
})
ListItem.displayName = "ListItem"
